<template>
    <div class="credits-auto-recharge credits-auto-recharge-border">
        <div class="credits-auto-recharge__top">
            <span class="credits-auto-recharge__title">
                Guarantee Delivery (Enable Auto Recharge)
            </span>
            <toggle-button
                v-model="form.is_active"
                :sync="true"
                :width="50"
                css-colors
                :labels="{
                    checked: 'On',
                    unchecked: 'Off',
                }"
            />
        </div>
        <div class="credits-auto-recharge__bottom">
            Automatically add <strong>1,000</strong> message credits to your account when your
            balance goes below 100 message credits.
        </div>
    </div>
</template>

<script>
import Form from 'core/Form';
import AutoRechargeMixin from 'mixins/auto-recharge';

export default {
    mixins: [AutoRechargeMixin],

    data() {
        return {
            form: new Form({
                is_active: false,
                threshold: 100,
                amount: 1000,
                backup: '',
            }),
            timeId: false,
        };
    },

    watch: {
        'form.is_active'(val) {
            if (this.timesCell) {
                clearTimeout(this.timeId);
            }
            this.timeId = setTimeout(() => {
                this.$store.dispatch('createBillingAutoRecharge', this.form);
            }, 1000);
        },

        autoRecharge(value) {
            if (value) {
                this.form.is_active = value.is_active;
                this.form.backup = value.backup;
            }
        },
    },

    mounted() {
        this.form.reset();

        if (this.autoRecharge) {
            this.form.is_active = this.autoRecharge.is_active;
            this.form.backup = this.autoRecharge.backup;
        }
    },
};
</script>
